import { Tabs, Tab } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setActiveModule } from "../store/slices/moduleSlice";

const ModuleTabs = () => {
  const dispatch = useDispatch();
  const availableModules = useSelector((state) => state.module.availableModules);
  const activeModule = useSelector((state) => state.module.activeModule);

  return (
    <Tabs
      value={activeModule}
      onChange={(_, val) => dispatch(setActiveModule(val))}
      sx={{
        minHeight: 36,
        "& .MuiTab-root": {
          minHeight: 36,
          fontSize: 13,
          fontWeight: 600,
          textTransform: "none",
          outline: "none",
          "&:focus": { outline: "none" },
          "&.Mui-focusVisible": { outline: "none", backgroundColor: "transparent" },
        },
      }}
    >
      {availableModules.includes("YARD") && <Tab label="Yard" value="YARD" />}
      {availableModules.includes("WAREHOUSE") && <Tab label="Warehouse" value="WAREHOUSE" />}
    </Tabs>
  );
};

export default ModuleTabs;